import { bindPrototypeMethodsToSelf } from '@wix/panorama-common/utils';
import { isCustomTransactionName } from '@wix/panorama-common-shared/utils';
export class PanoramaTransactionImpl {
  constructor(name, baseClient) {
    this.name = name;
    this.baseClient = baseClient;
    if (!isCustomTransactionName(name)) {
      throw new Error(`"${name}" is an internal transaction and can't be used`);
    }
    this.baseClient = baseClient;
    bindPrototypeMethodsToSelf(this);
  }
  start(data) {
    return this.baseClient.reportTransactionStart(this.name, data);
  }
  finish(data) {
    return this.baseClient.reportTransactionFinish(this.name, data);
  }
}
//# sourceMappingURL=panorama-transaction.js.map